/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { KorabArea } from './korabArea';
import { KorabCompetenceCategory } from './korabCompetenceCategory';
import { KorabLiteracy } from './korabLiteracy';

export interface KorabStructure { 
    areas: Array<KorabArea>;
    competenceCategories: Array<KorabCompetenceCategory>;
    literacies: Array<KorabLiteracy>;
}